import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertIcoToBmp() {
  return (
    <ImageConverterTemplate
      sourceFormat="ICO"
      targetFormat="BMP"
      acceptTypes=".ico,image/x-icon,image/vnd.microsoft.icon"
      slug="convert-ico-to-bmp"
      gradientColors="from-cyan-500 to-indigo-500"
      accentColor="blue"
    />
  );
}
